import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import "./index.css";
import { config } from "./lib/config";

Sentry.init({
  dsn: "https://c009a111bb61595c99e69f9380aab435@o4509634254077952.ingest.de.sentry.io/4509634255716432",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  _experiments: {
    enableLogs: true,
  },

  enabled: config.VITE_ENV !== "development",

  integrations: [
    Sentry.consoleLoggingIntegration({
      levels: ["log", "error", "warn"],
    }),
  ],

  environment: config.VITE_ENV,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
